import type { StyleLayer } from './utils/types'

export const layers_radinfra_smoothness: StyleLayer[] = [
  {
    id: 'smooth-missing',
    type: 'line',
    filter: [
      'any',
      ['!', ['has', 'smoothness']],
      ['match', ['get', 'smoothness'], [''], true, false],
    ],
    layout: {
      'line-cap': 'round',
      'line-join': 'round',
    },
    paint: {
      'line-color': '#fda5e4',
      'line-dasharray': [3, 1],
      'line-offset': ['interpolate', ['linear'], ['zoom'], 12, 0, 15, -1],
      'line-width': ['interpolate', ['linear'], ['zoom'], 12, 1, 22, 4],
    },
  },
  {
    id: 'smooth-colors',
    type: 'line',
    filter: ['has', 'smoothness'],
    layout: {
      'line-cap': 'round',
      'line-join': 'round',
    },
    paint: {
      'line-color': [
        'match',
        ['get', 'smoothness'],
        ['very_bad'],
        '#d8035c',
        ['bad'],
        '#f90606',
        ['intermediate'],
        '#faa00f',
        ['good'],
        '#b5ea2e',
        ['excellent'],
        '#37f644',
        'rgba(0, 0, 0, 0)',
      ],
      'line-offset': ['interpolate', ['linear'], ['zoom'], 12, 0, 15, -1],
      'line-width': ['interpolate', ['linear'], ['zoom'], 10, 1.5, 16, 4],
    },
  },
]
